export const benefitsChangeBg = [
	{
		icon: '🔹',
		subtitle: 'benefitData.subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData.subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData.subtitle3',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData.subtitle4',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData.subtitle5',
	},
	{
		icon: '🔹',
		subtitle: 'benefitData.subtitle6',
	},
];
